var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page"},[_c('ElementBrand'),_c('TheLogin',[(!_vm.passwordForget)?_c('TheLoginPanel'):_c('TheLoginPassword')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }